import FournisseursTab from "@features/achats/components/fournisseurs/FournisseursTab";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Truck } from "lucide-react";

export const Route = createFileRoute("/_app/achats/fournisseurs/")({
  staticData: {
    title: "Fournisseurs",
    icon: Truck,
    tab_icon: Truck,
    permission: PERMISSIONS.ACHATS.FOURNISSEURS.VIEW,
    module: "achats",
    order: 10,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: FournisseursTab,
});
